//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';

@Component({
	props : {
		minHeight : String,
	},
})
export default class TransitionHeight extends Vue {
	maxHeight = null;
	observer  = null;
	element   = null;

	created () {
		this.maxHeight = this.minHeight;
	}

	mounted () {
		this.element   = this.$refs.container;
		this.maxHeight = this.element.offsetHeight;
		this.observer  = new ResizeObserver(() => {
			this.maxHeight = this.element.offsetHeight;
		});

		this.observer.observe(this.element);
	}

	beforeDestroy () {
		this.observer.unobserve(this.element);
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<div class="transition-height-root" :style="{ minHeight, maxHeight: `${maxHeight}px` }">
	<div ref="container" class="slot-container">
		<slot />
	</div>

	<div class="stretcher" />
	<slot name="after" />
</div>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss">
@import '../assets/scss/constant.scss';

.transition-height-root {
	$overflow-buffer            : 50px;
	//---
	position                    : relative;
	overflow                    : hidden;
	margin                      : -$overflow-buffer;
	padding                     : $overflow-buffer;
	padding-bottom              : 0;
	margin-bottom               : 0;
	transition                  : max-height $x--transition-time ease-out;
	pointer-events              : none;

	& > * {
		pointer-events              : all;
	}
}

.slot-container {
	position                    : relative;
	/* Fix sizing */
	box-sizing                  : border-box;
	margin                      : -1px;
	border                      : 1px solid transparent;
}

.stretcher {
	height                      : 99999px;
	pointer-events              : none;
}
</style>
